<template>
  <div
    id="anim"
    class="bg-white rounded-lg shadow-md overflow-hidden relative z-0 transition-all ease-in-quad duration-500 cursor-pointer"
    v-on:click="openSlideOver"
  >
    <div class="relative">
      <div
        class="bg-blue-700 px-2 py-1 rounded text-white font-medium absolute z-10 m-4"
      >
        ${{ video.networkDisplayPrice }}
      </div>
      <div
        class="bg-gray-700 px-2 py-1 rounded text-white font-medium absolute z-10 m-4 right-0"
        :title="video.created_at | displayLocalDateTime"
        v-tippy
      >
        {{ video.created_at | timeAgo }}
      </div>
      <div class="stretch relative">
        <div
          class="absolute w-full h-full z-20 bg-red-600 bg-opacity-70 flex flex-col content-center items-center justify-center text-white text-center"
          v-if="video.embargo !== null"
        >
          <i class="fas fa-exclamation-circle text-4xl"></i>
          <p class="pt-2 px-2 lg:px-10">
            There is an embargo for this content. <br />
            <strong>{{ video.embargo }}</strong>
          </p>
        </div>
        <img
          class="filter-grayscale z-0 w-full blur"
          :src="'https://img.youtube.com/vi/' + video.youtube_id + '/0.jpg'"
        />
      </div>
    </div>
    <div class="font-semibold px-4 py-2">
      {{ video.title }}
    </div>

    <div
      class="flex items-center bg-blue-700 text-white text-sm font-bold px-4 py-3 mb-4"
      role="alert"
      v-if="video.purchased"
    >
      <p>
        <i class="fas fa-box-check mr-2"></i> A member of your network has
        already purchased this video. You may download the video again, if
        needed, without repurchasing.
      </p>
      <div class="flex-1 text-right">
        <button class="bg-white text-black rounded px-3 py-1">
          Download Video
        </button>
      </div>
    </div>

    <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2 mb-14 px-4 pb-4">
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">
          Rating
        </dt>
        <dd class="mt-1 text-gray-900">
          <StarRating :id="video.id" :rating="video.rating" />
        </dd>
      </div>
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">
          Credit
        </dt>
        <dd class="mt-1 text-gray-900">{{ video.user.name }} / LSM</dd>
      </div>
      <div class="sm:col-span-2">
        <dt class="text-sm font-medium text-gray-500">
          Narrative
        </dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ video.description | abbrDesc }}
        </dd>
      </div>
    </dl>

    <div
      class="w-full absolute bottom-0 p-4"
      v-if="!video.purchased || video.purchased == null"
      v-on:click="openSlideOver()"
    >
      <button
        class="px-3 py-2 bg-blue-700 text-white rounded w-full mt-5 md:mt-0"
      >
        Preview Video
      </button>
    </div>
  </div>
</template>
<script>
import StarRating from "@/components/general/StarRating";

export default {
  props: ["video"],
  components: { StarRating },
  data() {
    return {
      imageQuality: "maxresdefault"
    };
  },
  methods: {
    openSlideOver() {
      this.$eventBus.$emit("openSlideOver", this.video);
    }
  }
};
</script>
<style>
.filter-grayscale {
  filter: brightness(0.75);
}
#anim:active {
  transform: scale(0.97);
}
.blur {
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.2);
}
.stretch {
  padding-bottom: 56.25%; /* 16:9 */
  overflow: hidden;
}
.stretch > img {
  position: absolute;
  top: -16.75%;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
